import Api from "../config/Axios";
// import { getZoneList } from "../../services/zone.service";


export const getListingService = (token, user_id, param, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/issue/${param}`, {params:data, ...config});
};

export const postService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.patch(`api/web/tasks/mark-canceled-return-order-status/force`, data, config)
};

export const patchPickService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.patch(`api/web/issue/pick`, data, config)
};

export const patchPickBulkService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.patch(`api/web/issue/pick-bulk`, data, config)
};

export const patchInProcessService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.patch(`api/web/issue/complete`, data, config)
};